import BaseService from "./base-service";

export default class GroupService extends BaseService {

    constructor() {
        super('groups');
    }
}